var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnedited7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#010101;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.24,45.6c5.74-7.11,4.12-17.85-3.23-23.15c-0.08-0.06-0.15-0.12-0.21-0.18 c-8.86,7.31-15.81,16.86-19.98,27.77C22.67,53.61,32.57,52.63,38.24,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.37,76.41c-5.7-2.23-12.11-0.87-16.65,3.13c-1.17,1.03,0.54,2.72,1.7,1.71c3.69-3.25,8.79-4.34,13.47-2.82 c4.51,1.47,8.85,5.72,7.99,10.83c-0.25,1.52,2.07,2.17,2.32,0.64C71.24,83.73,66.87,78.56,61.37,76.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.14,87.35c-1.01,1.17,0.69,2.88,1.71,1.71c0.49-0.57,1.25-0.83,1.89-0.3c0.59,0.49,0.57,1.31,0.07,1.86 c-1.04,1.14,0.66,2.85,1.71,1.7c1.38-1.51,1.47-3.86-0.1-5.28C21.89,85.63,19.5,85.78,18.14,87.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.82,77.94c-0.85-1.29-2.93-0.09-2.08,1.22c2.8,4.27,8.99,3.88,13,1.7c4.53-2.46,7.09-7.59,6.51-12.69 c-0.17-1.52-2.59-1.54-2.41,0c0.46,3.98-1.16,7.99-4.6,10.18C125.42,80.15,120.02,81.3,117.82,77.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.31,104.92c-0.07,1.55,2.34,1.55,2.41,0c0.14-3.28,3.99-4.58,6.21-2.27c1.08,1.12,2.78-0.59,1.7-1.71 C116.9,97.07,110.54,99.62,110.31,104.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.29,82.73c-1.93-1.74-4.71-2.02-6.85-0.46c-1.24,0.91-0.04,3,1.22,2.08c1.24-0.91,2.75-0.98,3.93,0.08 C83.74,85.46,85.44,83.76,84.29,82.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.67,25.37c-0.88,1.17-2.31,1.32-3.6,0.81c-1.44-0.58-2.06,1.75-0.64,2.32c2.38,0.95,4.82,0.07,6.32-1.92 C110.69,25.36,108.6,24.15,107.67,25.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.7,25.7c-1.13,2.74-3.19,5.21-6.09,6.14c-2.81,0.89-5.93,0.05-7.48-2.55c-0.79-1.33-2.88-0.12-2.08,1.22 c2.01,3.36,6.03,4.76,9.77,3.78c3.99-1.04,6.68-4.27,8.2-7.94C96.61,24.91,94.28,24.29,93.7,25.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnedited7);
export default __webpack_public_path__ + "static/media/unedited7.5ea49e4a7ec301b9f4ba44aa401bf972.svg";
export { ForwardRef as ReactComponent };